import Link  from "next/link";
import React from "react";

import { storeEvent }    from "_analytics/index";
import BackgroundWrapper from "_components/atoms/backgroundWrapper";
import Icon              from "_components/atoms/icon";
import Image             from "_components/atoms/image";
import Typography        from "_components/atoms/typography";
import FollowUser        from "_components/molecules/followUser";
import useStyles         from "_styles/molecules/searchResultUserView";

const component = ( {
	sportsFanDetails,
	handleFollowGAEvent
} ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	let profileHref, profileAs;

	if ( sportsFanDetails ) {
		profileHref = "/profile/[userId]";
		profileAs   = `/profile/${ sportsFanDetails.id }`;
	}

	return (
		<BackgroundWrapper
			className = { classes.mainContianer }
		>
			<Link as       = { profileAs }
				href          = { profileHref }
				prefetch      = { false }
			>
				<div
					className = { classes.commentTopContainer }
					onClick   = { () => {
						storeEvent ( "Profile", "View", "Search" );
					} }
				>
					<Image alt       = "Rooter Profile"
						className       = { classes.commentAvatar }
						src             = { sportsFanDetails.photo }
						type            = "ldpi"
					/>

					<Typography
						className = { classes.commentName }
						title     = { sportsFanDetails.name }
					/>

					{/* <div className = { classes.commentNameContainer }>
						<span className     = { classes.commentName }>
							{sportsFanDetails.name}
						</span>
					</div> */}
				</div>
			</Link>

			<span onClick = { () => handleFollowGAEvent () }>
				<FollowUser
					followComponent   = { (
						<Icon className = { classes.svgIcon }
							name           = "follower"
						/>
					) }
					isFollowing       = { sportsFanDetails.isFollowing === 0 ? false : true }
					unfollowComponent = { (
						<Icon
							className = { classes.svgIcon }
							name      = "unfollow"
						/>
					) }
					userId            = { sportsFanDetails.id }
					userName          = { sportsFanDetails.name }
				/>
			</span>
		</BackgroundWrapper>
	);
};

export default component;
